import { createHttpLink } from "@apollo/client";
import createFetchWithRetry from "src/shared/helpers/createFetchWithRetry";
import getGraphQLApiUrl from "../getGraphQLApiUrl";

const httpLink = createHttpLink({
	uri: getGraphQLApiUrl(),
	credentials: "include",
	fetch: createFetchWithRetry({
		retries: 3,
		baseDelay: 10,
		maxDelay: 100,
		rewriteRequest: (_, options, { numAttempts }) => {
			return {
				url: getGraphQLApiUrl({
					numAttempts,
					headers: options?.headers,
				}),
				options,
			};
		},
	}),
});
export default httpLink;
